export default __webpack_public_path__ + "static/media/kfm_silo_slide.62f096fd.jpg";